module.exports = __webpack_public_path__ + "static/img/1.3173bad.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/16/zh/1.png
// module id = MzA3
// module chunks = 0